import CardServicos from './cardServicos'
import Container from './container'

export default function IntelligenceCards() {
  return (
    <section className="bg-[#040116] py-24">
      <Container className="grid md:grid-cols-2 gap-10 px-8 md:px-30">
        <CardServicos
          icon="../assets/icones/sheet.png"
          iconHover="../assets/gestao-icone.png"
          text="Apoiamos negócios no desenvolvimento e na submissão de projetos inovadores por meio da FINEP (Financiadora de Estudos e Projetos). Com direcionamento estratégico e suporte integral, a empresa estará pronta para buscar oportunidades de fomento que impulsionem suas linhas de inovação."
          glowColor="#FC00218C"
          url=""
          width="full"
          className="md:h-full"
        />
        <CardServicos
          icon="../assets/icones/arco.png"
          iconHover="../assets/gestao-icone.png"
          text="Inove com confiança contando com nosso direcionamento estratégico e especializado e desenvolva projetos que não somente cumpram exigências, mas que excedam as expectativas e gerem valor real."
          glowColor="#FC00218C"
          url=""
          width="full"
          className="md:h-full"
        />
      </Container>
    </section>
  )
}
